import React from 'react';
import { componentService } from 'js/services/component.service';

export const GamesGridGameInfo = React.lazy(() => import(/* webpackChunkName: "games-grid-game-info" */ './GamesGridGameInfo'));

componentService.registerPageComponents({ 'games-grid-game-info': GamesGridGameInfo });
